import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { eramanCMSApi } from "~/Services";

export interface DocumentDetailsResponse {
  id: string;
  image: string;
  title: string;
  field_common_malay_title: string;
  field_common_mandarin_title: string;
  body: string;
  field_common_malay_description: string;
  field_common_mandarin_descriptio: string;
  field_terms_and_conditions: string;
  field_malay_terms_and_conditions: string;
  field_mandarin_terms_and_conditi: string;
  field_created_date: string;
  field_updated_date: string;
  published: string;
  field_start_date: string;
  field_end_date: string;
}

// edit api call
const fetchAdvertisementPromotionsDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await eramanCMSApi.get(`/api/campaign/all-fields/${id}`);
  return response.data?.[0];
};

const useCampaignDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["campaign", id],
      enabled: false,
      queryFn: () => {
        return fetchAdvertisementPromotionsDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useCampaignDocumentDetails };
